module.exports = {"Phase 3b":{"E1":["Basement","Ground","1","2","3","4","5","6","7","8","9","10","11","Roof"],"E2":["Basement","Ground","1","2","3","4","5","6","7","8","9","Roof"],"E3":["Basement","Ground","1","2","3","4","5","6","7","8","9","10","11","12","13","Roof"],"Resi-Facilities":["Ground"]},"Phase 3a":{"D4":["Basement","Ground","1","2","3","4","5","6","7","8","9","10","Roof"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/alexandraGate.json
// module id = 110
// module chunks = 0